import pl from "@locales/calendar_visits/pl.json";
import en from "@locales/calendar_visits/en.json";

export default { pl, en };
